// Sade Teklif - Default degerler

export const DEFAULT_TABLE_ROWS = [
  {
    id: "cay",
    makineModeli: "3+1ÇAYSET",
    urun: "Çay",
    urunAylikKg: 0,
    bardakAylikAdet: 0,
    adetFiyat: 0,
    personelSayisi: 0,
    makineSayisi: 0,
  },
];

export const MAKINE_MODELI_OPTIONS = [
  "3+1ÇAYSET",
  "3+1FİNCANDA",
  "ESPRESSO",
  "ÇAYSET",
  "FİNCANDA",
];

// Makine modeline gore default urun eslesmesi
export const MAKINE_URUN_MAP = {
  "3+1ÇAYSET": [
    "Çay",
    "Filtre Kahve",
    "Yedek Makine",
  ],
  "3+1FİNCANDA": [
    "Türk Kahvesi",
    "Filtre Kahve",
  ],
  ESPRESSO: ["Espresso"],
  ÇAYSET: ["Çay", "Yedek Makine"],
  FİNCANDA: ["Türk Kahvesi"],
};

// Yeni satir icin fabrika fonksiyonu
export const createNewRow = (makineModeli, urun) => ({
  id: `row_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
  makineModeli,
  urun: urun || (MAKINE_URUN_MAP[makineModeli]?.[0] ?? ""),
  urunAylikKg: 0,
  bardakAylikAdet: 0,
  adetFiyat: 0,
  personelSayisi: 0,
  makineSayisi: 0,
});

export const DEFAULT_CONTENT = {
  tarih: new Date().toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }),
  firmaAdi: "",
  departman: "SATIN ALMA MÜDÜRLÜĞÜNE",
  konu: "Fabrika yerleşkelerinde Konsinye Sıcak İçecek Sistemleri, Sabit İstihkaklı İşletim ve İşgücü",
  giris: `{FIRMA} yerleşkelerindeki Sıcak İçecek operasyonlarının tek merkezden, kesintisiz ve sabit maliyetli bir yapıda yönetilmesi amacıyla hazırladığımız "Entegre İşletim ve İK Optimizasyonu" Minimum 3 yıllık sözleşme ile teklifimiz aşağıda bilgilerinize sunulmuştur.`,
  bolum1Giris: `Bu proje bir "satın alma" değil, "hizmet kiralama ve operasyon devri" modelidir.`,
  bolum1Madde1: `Konsinye Cihaz Altyapısı: Tesisinizde belirlenen noktalara endüstriyel Çay ve Kahve makineleri konsinye (bedelsiz kullanım) olarak konumlandırılacaktır. Cihaz mülkiyeti firmamıza aittir.`,
  bolum1Madde2: `Sabit İşletim Geliri (Alım Garantisi): Operasyonun finansal sürdürülebilirliği için faturalandırma, gerçekleşen tüketimden bağımsız olarak "Aylık Sabit Tüketim Kotası" üzerinden yapılacaktır. Tüketim bu kotanın altında kalsa dahi taahhüt edilen sabit tutar tahsil edilecek, kotayı aşan kullanımlar ayrıca faturalandırılacaktır.`,
  bolum2Icerik: `Cihazların günlük bakımı, hammadde yükleme {FIRMA} personeli tarafında yapılacak olup olası arızalara müdahale online ve veya İstanbul içi 24 saat İstanbul dışı bütün Türkiye'de 72 saatte müdahale edilerek hizmet akışı sağlanacaktır.`,
  bolum2IK: `{FIRMA} için İK Optimizasyonu (Katma Değer): Bu anahtar teslim model sayesinde, halihazırda bu hizmetler için efor sarf eden mevcut personelinizin en az %30 verimlilik artışı sağlanabilecektir.`,
  tabloNot: `(Not: Bu tablo, her ay {FIRMA} ya kesilecek olan standart sabit faturayı temsil etmektedir.)`,
  tabloOzet: "",
  bolum4Icerik: `Geçerlilik ve Sözleşme: Teklifimiz 30 gün geçerlidir. Minimum 3 yıllık Sözleşme süresi boyunca aylık sabit fatura tutarı, "tüketim miktarına bakılmaksızın" her ayın ilk haftası faturalandırılacak olup her yıl TEFE +TÜFE /2 olarak fiyat güncellenecektir.`,
  kapanis: `Operasyonel yükünüzü ciddi şekilde azaltarak, kurumunuza ciddi bir işgücü tasarrufu sağlayacak bu projenin hayata geçirilmesini onaylarınıza sunarız.`,
  imzaAd: "Muammer BAYINDIR",
  imzaGorev: "Genel Müdür",
  imzaUnvan:
    "OKKALI KAHVE VE İÇECEK ÜRÜNLERİ TİC. VE SAN. A.Ş.",
};

// Tablo hesaplama yardimcilari

// Personel basina tuketim: bardakAylikAdet / personelSayisi
export const calcPersonelBasinaTuketim = (row) =>
  (row.personelSayisi || 0) > 0
    ? (row.bardakAylikAdet || 0) / (row.personelSayisi || 1)
    : 0;

// Personel basina maliyet: adetFiyat * personelBasinaTuketim
export const calcPersonelBasinaMaliyet = (row) =>
  (row.adetFiyat || 0) * calcPersonelBasinaTuketim(row);

export const calcToplamFiyat = (row) =>
  (row.adetFiyat || 0) * (row.bardakAylikAdet || 0);

export const calcTotals = (rows) => {
  let toplamPersonelMaliyet = 0;
  let toplamMakineSayisi = 0;
  let toplamFiyat = 0;

  rows.forEach((row) => {
    toplamPersonelMaliyet += calcPersonelBasinaMaliyet(row);
    toplamMakineSayisi += row.makineSayisi || 0;
    toplamFiyat += calcToplamFiyat(row);
  });

  return { toplamPersonelMaliyet, toplamMakineSayisi, toplamFiyat };
};

// TL para formatlama
export const formatTL = (value) => {
  if (value === 0) return "0,00 TL";
  return (
    new Intl.NumberFormat("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value) + " TL"
  );
};

// Sayi formatlama (ondalik)
export const formatNum = (value) => {
  if (value === 0) return "0";
  if (Number.isInteger(value)) return String(value);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(value);
};
